export default "__VITE_ASSET__Cqi0mdND__"